"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createOrbitControls = void 0;
const OrbitControls_js_1 = require("three/examples/jsm/controls/OrbitControls.js");
function createOrbitControls(camera, canvas) {
    const controls = new OrbitControls_js_1.OrbitControls(camera, canvas);
    // Enable individual mode
    controls.enableRotate = true;
    controls.enableZoom = true;
    controls.enablePan = true;
    // Disable arrow keys to pan the camera
    // controls.enableKeys = false;
    // Damping (inertia)
    controls.enableDamping = false;
    // Autorotate around the target
    controls.autoRotate = false;
    controls.autoRotateSpeed = 1;
    // Zoom limit
    controls.minDistance = 0.1;
    controls.maxDistance = 1000;
    // Horizontal rotation limit
    controls.minAzimuthAngle = -Infinity; // default Infinity
    controls.maxAzimuthAngle = Infinity; // default Infinity
    // Vertical rotation limit
    controls.minPolarAngle = 0; // default 0
    controls.maxPolarAngle = Math.PI; // default Math.PI
    return controls;
}
exports.createOrbitControls = createOrbitControls;
